import clsx from "clsx";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Text } from "@medoma/components/Text/Text";
import styles from "./Checkboxes.module.scss";

interface ICheckboxes {
  children: React.ReactNode;
  description?: string;
  errorMessage?: string;
  icon?: React.ReactNode;
  legend?: string;
  orientation?: "vertical" | "horizontal";
  width?: "hug-content" | "fill-container";
}
const Checkboxes = ({
  children,
  description,
  errorMessage,
  icon,
  legend,
  orientation = "vertical",
  width = "hug-content",
}: ICheckboxes) => {
  return (
    <fieldset className={styles.checkboxesFieldset}>
      {icon || legend ? (
        <legend className={styles.legend}>
          {icon}
          {legend}
        </legend>
      ) : undefined}
      {description ? (
        <Text element="span" color="faded">
          {description}
        </Text>
      ) : undefined}
      {errorMessage ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={errorMessage} weight="bold" />
        </div>
      ) : undefined}
      <div
        className={clsx(
          styles.checkboxes,
          styles[orientation],
          styles[`width-${width}`],
        )}
      >
        {children}
      </div>
    </fieldset>
  );
};

export default Checkboxes;
